/**
 * Bilingual copy for the Demo page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 * Demo credentials/urls are kept in DemoPage.tsx itself.
 */
export const en = {
  eyebrow: 'Demo Environment',
  title: 'Full Featured Demo',
  description:
    'Open a live demo and click around — no signup needed. HR, clinic, and store demos are ready to try with the credentials below.',
  usernameLabel: 'Username:',
  passwordLabel: 'Password:',
  openDemo: 'Open Demo',
  items: [
    {
      key: 'frontStore',
      title: 'Front Store Demo',
      description:
        'Customer-facing AKAS online store: catalog, browsing, and checkout on the same items as the ERP.',
    },
    {
      key: 'storeAdmin',
      title: 'Store Admin Demo',
      description: 'Store admin: products, banners, payments, and day-to-day storefront setup.',
    },
    {
      key: 'hrSystem',
      title: 'HR System Demo',
      description: 'HRMS self-service, personnel, leave, attendance, and payroll screens.',
    },
    {
      key: 'clinic',
      title: 'Clinic Demo',
      description: 'Clinic queue, consultation, dispensary, and payment on a live demo.',
    },
  ],
};

export type Copy = typeof en;

export const km: Copy = {
  eyebrow: 'បរិស្ថានសាកល្បង',
  title: 'សាកល្បងមុខងារពេញលេញ',
  description:
    'បើកការបង្ហាញសាកល្បងផ្ទាល់ ហើយចុចមើលបានតាមចិត្ត — មិនចាំបាច់ចុះឈ្មោះទេ។ យើងបានរៀបចំការសាកល្បងសម្រាប់ផ្នែកធនធានមនុស្ស គ្លីនិក និងហាង ដោយប្រើព័ត៌មានចូលប្រើខាងក្រោម។',
  usernameLabel: 'ឈ្មោះអ្នកប្រើប្រាស់៖',
  passwordLabel: 'ពាក្យសម្ងាត់៖',
  openDemo: 'បើកការសាកល្បង',
  items: [
    {
      key: 'frontStore',
      title: 'សាកល្បងហាងអនឡាញ',
      description:
        'ហាងអនឡាញរបស់ AKAS សម្រាប់អតិថិជន៖ មើលបញ្ជីទំនិញ ជ្រើសរើសទំនិញ និងទូទាត់លើទំនិញដូចគ្នានឹងប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម។',
    },
    {
      key: 'storeAdmin',
      title: 'សាកល្បងផ្ទាំងគ្រប់គ្រងហាង',
      description: 'ផ្ទាំងគ្រប់គ្រងហាង៖ ទំនិញ ផ្ទាំងផ្សព្វផ្សាយ ការទូទាត់ និងការរៀបចំហាងប្រចាំថ្ងៃ។',
    },
    {
      key: 'hrSystem',
      title: 'សាកល្បងប្រព័ន្ធធនធានមនុស្ស',
      description: 'អេក្រង់ធនធានមនុស្ស៖ សេវាដោយខ្លួនឯង ព័ត៌មានបុគ្គលិក ការឈប់សម្រាក វត្តមាន និងការគណនាប្រាក់ខែ។',
    },
    {
      key: 'clinic',
      title: 'សាកល្បងគ្លីនិក',
      description: 'ជួររង់ចាំអ្នកជំងឺ ការពិគ្រោះព្យាបាល ការចេញឱសថ និងការទូទាត់ — សាកល្បងបានផ្ទាល់។',
    },
  ],
};
